import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  ButtonAddApprover,
  ContentActions,
  ContentSelectors,
  GeneralStyle,
} from "./ApproversComponent.styled";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import AddCommentIcon from "@material-ui/icons/AddComment";
import InviteUsersGroupsContainer from "../../containers/InviteUsersGroupsContainer/InviteUsersGroupsContainer";
import { useLazyQuery } from "@apollo/client";
import { ALL_ROLES_BY_LEVEL, USERS_IN_ROLE2 } from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import { ROLES } from "../../util/RolesConstants";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";

const ApproversComponent = ({
  formTrigger,
  usersSelected,
  groupsSelected,
  setUsersSelected,
  setGroupsSelected,
  createNew,
  approverSelected,
  setApproverSelected,
  userDeleted,
  groupDeleted,
  setUserDeleted,
  setGroupDeleted,
}) => {
  const [allRolesByLevel, setAllRolesByLevel] = useState([]);
  const user = useMemo(() => getStateLoginComplete(), []);
  const [listApprovers, setListApprovers] = useState();
  const rApprovers = useRef();
  const [editData, setEditData] = useState([]);
  const usersSelection = useMemo(() => [], []);
  const groupsSelection = useMemo(() => [], []);
  const [disabledSelector, setDisabledSelector] = useState(true);
  const [runQueryRolesByLevel] = useLazyQuery(ALL_ROLES_BY_LEVEL, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllRolesByLevel = data.rolesByUserProfile.map((element) => {
        return {
          value: element?.roleId,
          label: element?.friendlyDescription,
          roleLevel: element?.roleLevel,
        };
      });
      setAllRolesByLevel(resultOfAllRolesByLevel);
    },
  });

  const [runQueryUsersInRole2] = useLazyQuery(USERS_IN_ROLE2, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersInRole2 = data.userListAdvancedSearch.map((element) => {
        return {
          value: element?.userId,
          label:
            element?.userFirstName +
            " " +
            element?.userLastName +
            " " +
            element?.userCcms,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
          emailAddress: element?.userTpId,
          ccmsid: element?.userCcms,
          ccmsuser: element?.userCcms,
        };
      });
      setListApprovers(usersInRole2);
    },
  });

  useEffect(() => {
    if (user.roleId) {
      runQueryRolesByLevel({
        variables: { roleId: user.roleId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [formTrigger]);

  useEffect(() => {
    let rolesIdFiltered = allRolesByLevel.filter(
      (element) => element.value != ROLES.AGENT
    );
    let rolesId = rolesIdFiltered.map((item) => item.value);
    if (user.roleId && rolesId.length > 0) {
      runQueryUsersInRole2({
        variables: { rolesId: rolesId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [allRolesByLevel]);

  useEffect(() => {
    if (usersSelection || groupsSelection) {
      setEditData({
        guests: usersSelection,
        groups: groupsSelection,
      });
    }
  }, [usersSelection, groupsSelection]);

  useEffect(() => {
    if (approverSelected) {
      setDisabledSelector(false);
    } else {
      setDisabledSelector(true);
    }
  }, [approverSelected]);

  return (
    <GeneralStyle className="pb-5">
      <ContentSelectors className="mb-2">
        <Row
          style={{ display: "flex", flexDirection: "column" }}
          className="mx-2"
        >
          <Col>
            <p>
              <Form.Label
                style={{
                  color: themeConfig.neutral.black,
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Select the approver
              </Form.Label>
              <Select
                placeholder="Select a user"
                ref={rApprovers}
                options={listApprovers}
                onChange={(e) => {
                  setApproverSelected(e.value);
                }}
              />
            </p>
          </Col>
          <Col className="pt-3">
            <InviteUsersGroupsContainer
              fieldLabel={"Approve users"}
              groupAssignLabel={"Group assignation"}
              editData={editData}
              action={"add"}
              usersSelected={usersSelected}
              setUsersSelected={setUsersSelected}
              groupsSelected={groupsSelected}
              setGroupsSelected={setGroupsSelected}
              showIconFieldLabel={true}
              disabledSelector={disabledSelector}
              userDeleted={userDeleted}
              groupDeleted={groupDeleted}
              setUserDeleted={setUserDeleted}
              setGroupDeleted={setGroupDeleted}
            />
          </Col>
        </Row>
      </ContentSelectors>
      <ContentActions>
        <ButtonAddApprover
          disabledSelector={disabledSelector}
          onClick={() => {
            if (!disabledSelector) {
              createNew(groupsSelected, usersSelected);
            }
          }}
        >
          <AddCommentIcon
            style={{ transform: "scaleX(-1)", marginRight: "0.5em" }}
          />{" "}
          Save
        </ButtonAddApprover>
      </ContentActions>
    </GeneralStyle>
  );
};

ApproversComponent.propTypes = {
  formTrigger: PropTypes.string,
  usersSelected: PropTypes.array,
  setUsersSelected: PropTypes.func,
  groupsSelected: PropTypes.array,
  setGroupsSelected: PropTypes.func,
  createNew: PropTypes.func,
  approverSelected: PropTypes.number,
  setApproverSelected: PropTypes.func,
  userDeleted: PropTypes.array,
  setUserDeleted: PropTypes.func,
  groupDeleted: PropTypes.array,
  setGroupDeleted: PropTypes.func,
}

export default ApproversComponent;
